export default __webpack_public_path__ + "static/media/image_footer.eed2fc44.svg";